
import {DigitizationTools} from "../ToolRegistry.js";
import {runPerpendicularCapture} from "./perpendicularCapture.js";

import {T} from "../i18n/index.js";
// "Vinkelret punkt": digitize a baseline, then register a single point
// constrained to lie perpendicular (in XY) to that baseline - see
// tools/perpendicularCapture.js for the shared capture flow and
// geometry/perpendicularConstraint.js for the projection/constraint math.
// The baseline and every preview visual are pure construction geometry and
// are discarded once the point is committed - only the point persists.
export const PerpendicularPointTool = {
	id: "digitize_perpendicular_point",
	name: T("Vinkelret punkt"),
	category: "specialized",
	kind: "registration",
	toolbarGroup: "registration",
	toolbarOrder: 120,
	icon: "perpendicular_point.svg",
	resultGeometryType: "Point",
	featureType: T("Vinkelret punkt"),

	tooltip: T("Digitalisér først en basislinje. Herefter kan et punkt registreres vinkelret på basislinjen."),

	instructions: {
		baseline: T("Basislinje: Venstreklik for at placere punkter langs basislinjen. Højreklik for at afslutte basislinjen."),
		perpendicular: T("Vælg en position i punktskyen - punktet fastlåses vinkelret på basislinjen. Venstreklik for at gemme punktet."),
	},

	customCapture(dm, tool){
		runPerpendicularCapture(dm, tool, "point");
	},
};

DigitizationTools.register(PerpendicularPointTool);
